/* global logger */
/* eslint-disable class-methods-use-this */
const moment = require('moment');
const Helper = require('./utils/helper');
const { orderType: OrderType, movementType, sourceAndDestinationType, detentionDefaults } = require('pando-constants');
const { MomentInitializer } = require('pando-holiday-lib');
const { isEmpty } = require('lodash');

const IST_OFFSET = 3600000 * 5.5;
const MS_PER_HOUR = 3600000;

class UnloadingDetention {
  getMomentDaysTimeOffset(momentVal) {
    return ((((momentVal.hour() * 60) + momentVal.minutes()) * 60) + momentVal.seconds()) * 1000;
  }

  calculateDetentionDays(detentionStartedAt, detentionEndedAt, start, end,
    depotCalenderMap, destinationLocationId, unloadingDetentionConfig = null,
    unloadingDetentionDetailConfig, indentMovementType, reportedAt, sourceLocationId) {
    let notConsiderHoliday = false;
    let detentionConfigThresholdTime;
    let detentionConfigStartTime;

    if (unloadingDetentionDetailConfig) {
      detentionConfigThresholdTime = (unloadingDetentionDetailConfig &&
        unloadingDetentionDetailConfig.threshold_time) || detentionDefaults.threshold_time;
      detentionConfigStartTime = (unloadingDetentionDetailConfig &&
        unloadingDetentionDetailConfig.start_time) || detentionDefaults.start_time;
    } else if (unloadingDetentionConfig && unloadingDetentionConfig.isDetentionV2Enabled) {
      detentionConfigThresholdTime = unloadingDetentionConfig.threshold_time ||
        detentionDefaults.threshold_time;
      detentionConfigStartTime = unloadingDetentionConfig.start_time ||
        detentionDefaults.start_time;
    } else {
      detentionConfigThresholdTime = (unloadingDetentionConfig && unloadingDetentionConfig.detentions_defaults
          && unloadingDetentionConfig.detentions_defaults.threshold_time) || detentionDefaults.threshold_time;
      detentionConfigStartTime = (unloadingDetentionConfig && unloadingDetentionConfig.detentions_defaults
          && unloadingDetentionConfig.detentions_defaults.start_time) || detentionDefaults.start_time;
    }
    const currentDepotDetentionConfigCheck = [movementType.SECONDARY, movementType.INWARD, movementType.RETURNS];
    const isHolidayConsiderationExists = (
      (currentDepotDetentionConfigCheck.includes(indentMovementType) && unloadingDetentionConfig
        && unloadingDetentionConfig.holiday_consideration) ||
      (indentMovementType === movementType.PRIMARY && unloadingDetentionDetailConfig
        && unloadingDetentionDetailConfig.holiday_consideration)
    );

    if (reportedAt && detentionConfigThresholdTime && isHolidayConsiderationExists) {
      const reportedAtTime = moment(reportedAt).format('HH:mm');
      if (reportedAtTime < detentionConfigThresholdTime) {
        notConsiderHoliday = true;
      }
    }

    let depotHolidays = depotCalenderMap ? (
      ((indentMovementType === movementType.SECONDARY) ?
        depotCalenderMap[`${sourceLocationId}`] :
        depotCalenderMap[`${destinationLocationId}`]) || null) :
      null;
    if (notConsiderHoliday) {
      depotHolidays = {};
    }
    const momentBusinessDays = MomentInitializer.getHolidayAdjustedCalendar(depotHolidays);
    let _detentionStartedAt;
    if (unloadingDetentionConfig) {
      const _detentionStartedTime = moment(new Date(detentionStartedAt).getTime() + IST_OFFSET);
      const _detentionConfigStartedTimeHours = moment(_detentionStartedTime).format('HH:MM');
      const detentionNextStartDate = moment(_detentionStartedTime).add(1, 'days').format('YYYY-MM-DD');
      const [detentionConfigStartTimeHour, detentionConfigStartTimeMins] = detentionConfigStartTime.split(':');
      const _detentionConfigStartedAt = moment(detentionNextStartDate).add(detentionConfigStartTimeHour, 'hours').add(detentionConfigStartTimeMins, 'minutes');
      _detentionStartedAt = (_detentionConfigStartedTimeHours < detentionConfigThresholdTime) ? _detentionStartedTime : _detentionConfigStartedAt;
    } else {
      _detentionStartedAt = moment(new Date(detentionStartedAt).getTime() + IST_OFFSET);
    }
    const _detentionEndedAt = moment(new Date(detentionEndedAt).getTime() + IST_OFFSET);
    let difference;

    // if _detentionStartedAt is not business day find next business day
    if (!momentBusinessDays.isBusinessDay(_detentionStartedAt.clone()) && !notConsiderHoliday) {
      const nextBusinessDay = momentBusinessDays.nextBusinessDay(_detentionStartedAt.clone()).startOf('day');
      if (moment(nextBusinessDay).isSameOrAfter(_detentionEndedAt, 'days')) {
        difference = 0;
        return difference;
      }
      _detentionStartedAt = nextBusinessDay;
    }
    // let prevBusinessDayCheck = false;
    // if _detentionEndedAt is not business day find previous business day
    // if (unloadingDetentionConfig && !depotCalendar(_detentionEndedAt).isBusinessDay()) {
    //   const previousBusinessDay = depotCalendar(_detentionEndedAt).prevBusinessDay().endOf('day');
    //   if (moment(previousBusinessDay).isSameOrBefore(_detentionStartedAt, 'days')) {
    //     difference = 0;
    //     return difference;
    //   }
    //   prevBusinessDayCheck = true;
    //   _detentionEndedAt = previousBusinessDay;
    // }
    // const nonWorkingHours = 0;
    // let started = moment(_detentionStartedAt).add(1, 'days').startOf('day');
    // // non working hours between detentionStart and detentionEnd
    // if (unloadingDetentionConfig) {
    //   while (moment(started).isBefore(_detentionEndedAt)) {
    //     if (!depotCalendar(started).isBusinessDay()) {
    //       nonWorkingHours += 24;
    //     }
    //     started = moment(started).add(1, 'days');
    //   }
    // }
    if (unloadingDetentionConfig) {
      // if (prevBusinessDayCheck) {
      //   _detentionEndedAt = moment(_detentionEndedAt).add(1, 'second');
      // }
      difference = this.calculateDifferenceBasedOnDepotConfig(_detentionStartedAt,
        _detentionEndedAt);
      // difference -= nonWorkingHours;
    } else {
      difference = this.calculateDifferenceBasedOnWindow(_detentionStartedAt,
        _detentionEndedAt, start, end);
    }
    return difference;
  }

  calculateDifferenceBasedOnDepotConfig(detentionStartAt, detentionEndAt) {
    const difference = detentionEndAt.diff(detentionStartAt, 'hours');
    if (difference < 0) {
      return 0;
    }
    return difference;
  }

  calculateDifferenceBasedOnWindow(detentionStartAt, detentionEndAt, start, end) {
    const detentionEndedDaysOffsetMillis = this.getMomentDaysTimeOffset(detentionEndAt);
    const detentionStartedDaysOffsetMillis = this.getMomentDaysTimeOffset(detentionStartAt);

    const difference = detentionEndAt.startOf('day').diff(detentionStartAt.startOf('day'), 'days');

    if (difference < 0) {
      return 0;
    }
    if (difference) {
      const result = (difference - 1) + (detentionStartedDaysOffsetMillis < start ? 1 : 0) +
        (detentionEndedDaysOffsetMillis > end ? 1 : 0);
      return result;
    }
    const singleDayResult = ((detentionStartedDaysOffsetMillis < start) &&
    (detentionEndedDaysOffsetMillis > end)) ? 1 : 0;
    return singleDayResult;
  }

  calculateDeliveryDetentionBasedOnDepotConfiguration(data, depotCalenderMap, unloadingDetentionConfig) {
    let sum = 0;
    const unloadingDetentionDetailConfig = data.unloadingDetentionDetailConfig;
    const masterDepot = data.routeDetails && data.routeDetails.depot_id;
    data.destinations.forEach((destination) => {
      let currentDepotDetentionConfig;
      let currentDepotDetentionDetailConfig;
      if (data.movement === movementType.INWARD || data.movement === movementType.RETURNS) {
        const depotId = masterDepot || destination.locationId;
        currentDepotDetentionConfig = unloadingDetentionConfig.find(config =>
          depotId.toString() === config.depotId.toString());
      } else {
        const depotId = masterDepot || destination.sourceLocationId;
        currentDepotDetentionConfig = unloadingDetentionConfig.find(config =>
          depotId.toString() === config.depotId.toString());
        currentDepotDetentionDetailConfig = unloadingDetentionDetailConfig.find(config =>
          destination.locationId.toString() === config.depotId.toString());
      }
      if (currentDepotDetentionConfig) {
        const reportedAt = new Date(destination.reportedAt);
        const releaseAt = new Date(destination.releaseAt);
        const expectedDate = new Date(destination.expectedDeliveryDate);
        let arrivedEarlyHours = 0;
        let arrivedEarlyDays = 0;
        if (expectedDate && expectedDate.getTime() > reportedAt.getTime()) {
          const detentionReportedTime = moment(reportedAt.getTime());
          const detentionExpectedTime = moment(expectedDate.getTime());
          arrivedEarlyHours = detentionExpectedTime.diff(detentionReportedTime, 'hours');
          const duration = (currentDepotDetentionConfig && currentDepotDetentionConfig.unloadingDetention 
            && currentDepotDetentionConfig.unloadingDetention.duration) || MS_PER_HOUR * 24;
          const durationInHours = duration / MS_PER_HOUR;
          arrivedEarlyDays = arrivedEarlyHours < 0 ? 0 : Math.floor(arrivedEarlyHours / durationInHours);
        }
        const detentionStartTime = moment(reportedAt.getTime());
        const detentionEndTime = moment(releaseAt.getTime());
        const currentDepotDetentionConfigCheck = [movementType.SECONDARY, movementType.INWARD, movementType.RETURNS];
        if ((currentDepotDetentionConfigCheck.includes(data.movement) && !currentDepotDetentionConfig.include_holiday) ||
          (data.movement === movementType.PRIMARY && currentDepotDetentionDetailConfig &&
          !currentDepotDetentionDetailConfig.include_holiday)) {
          // eslint-disable-next-line no-param-reassign
          depotCalenderMap = null;
        }
        let days = 0;
        if (currentDepotDetentionConfig && currentDepotDetentionConfig.operationBasedThresholdEnabled &&
          currentDepotDetentionConfig.operationBasedThresholdEnabled === true) {
          days = this.calculateDetentionDays(
            detentionStartTime.valueOf(), detentionEndTime.valueOf(),
            currentDepotDetentionConfig.start_time, currentDepotDetentionConfig.end_time, depotCalenderMap, destination.locationId);
        } else {
          const _hours = this.calculateDetentionDays(detentionStartTime, detentionEndTime,
            null, null, depotCalenderMap, destination.locationId, currentDepotDetentionConfig, currentDepotDetentionDetailConfig,
            data.movement, reportedAt, destination.sourceLocationId);
          days = Math.floor(_hours / (currentDepotDetentionConfig.unloadingDetention.duration / MS_PER_HOUR));
        }
        
        let detentionDays = 0;
        if (currentDepotDetentionConfig.operationBasedThresholdEnabled) {
          // For window-based calculation, use days directly without early arrival adjustment
          detentionDays = days;
        } else if ((currentDepotDetentionDetailConfig
          && currentDepotDetentionDetailConfig.unloading_detention_start_from_reported_at) ||
          ((data.movement === movementType.INWARD || data.movement === movementType.RETURNS)
            && currentDepotDetentionConfig.unloading_detention_start_from_reported_at)) {
          detentionDays = days;
        } else if (days > arrivedEarlyDays) {
          detentionDays = days - arrivedEarlyDays;
        }
        const addToSum = (destination.type === sourceAndDestinationType.CONSIGNEE && destination.group && destination.group.length && !(destination.include)) ? 0 : Number(detentionDays);
        sum += addToSum;
      } else {
        logger.error(`currentDepotDetentionConfig missing for destination ${destination.locationId.toString()}`);
      }
    });
    return sum;
  }

  calculateDeliveryDetentionBasedOnClientConfiguration(data, depotCalenderMap,
    unloadingDetentionClientConfig) {
    let max = 0;
    const dayinMilliseconds = 24 * 60 * 60 * 1000;
    const { startedAt: start, endedAt: end } = data.sla.detention.expectedDetentionWindowUnloading;
    if (start && end) {
      let dispatchedAt;
      if (data.sla.detention.actualDetentionWindowByDepot
        && !isEmpty(data.sla.detention.actualDetentionWindowByDepot)) {
        const actualDetentions = Object.values(data.sla.detention.actualDetentionWindowByDepot);
        const lastDepotDetention = actualDetentions.reduce((d1, d2) =>
          (Date.parse(d2.endedAt) > Date.parse(d1.endedAt) ? d2 : d1));
        dispatchedAt = lastDepotDetention.endedAt;
      }
      data.destinations.forEach((destination) => {
        const allowedTransitDays = destination.transitTime * dayinMilliseconds;
        const detentionStartTime = moment(new Date(destination.reportedAt)
          .getTime() + IST_OFFSET);
        const detentionStartTimeWithDetention = moment(new Date(dispatchedAt)
          .getTime() + IST_OFFSET
        + allowedTransitDays);

        /**
         * Do not add IST OFFSET since it is added in calculateDetentionDays method
         */
        const detentionEndTime = moment(new Date(destination.releaseAt).getTime());

        let detentionStart;
        if (unloadingDetentionClientConfig
          && unloadingDetentionClientConfig.start_from_reported_at) {
          detentionStart = detentionStartTime;
        } else {
          detentionStart = (detentionStartTime > detentionStartTimeWithDetention)
            ? detentionStartTime : detentionStartTimeWithDetention;
        }

        if (unloadingDetentionClientConfig && unloadingDetentionClientConfig.exclude_holiday) {
          // eslint-disable-next-line no-param-reassign
          depotCalenderMap = null;
        }

        const days = this.calculateDetentionDays(
          (detentionStart).valueOf() - IST_OFFSET, detentionEndTime,
          start, end, depotCalenderMap, destination.locationId);
        max = Math.max(max, Number(days));
      });
    }
    return max;
  }

  calculateChargeForDetention(charges, days) {
    let detentionCharge = 0;
    let detentionDays = days;
    for (let chargeIndex = 0; chargeIndex < charges.length && detentionDays;
      detentionDays -= 1, chargeIndex += 1) {
      detentionCharge += charges[chargeIndex];
    }
    if (detentionDays > 0) {
      detentionCharge += charges[charges.length - 1] * (detentionDays);
    }
    return detentionCharge.toFixed(2);
  }

  calculateDeliveryDetentionBasedOnExpectedDelivery(data, depotCalenderMap) {
    const unloadingDetentionConfig = data.unloadingDetentionConfig;
    const unloadingDetentionClientConfig = data.detentionClientConfig &&
      data.detentionClientConfig.unloadingDetention;
    let days = 0;
    if (unloadingDetentionConfig && unloadingDetentionConfig.length) {
      logger.info(`[unloadingDetention] unloadingDetentionConfig- -${data.orderNo} calculating unloading delay in discrepancy by depot configuration`);
      days = this.calculateDeliveryDetentionBasedOnDepotConfiguration(data, depotCalenderMap,
        unloadingDetentionConfig);
    } else if (data.detentionBasedOnClient.unloadingDetention) {
      logger.info(`[unloadingDetention] detentionBasedOnClient -${data.orderNo} calculating unloading delay in discrepancy by client configuration`);
      days = this.calculateDeliveryDetentionBasedOnClientConfiguration(data, depotCalenderMap,
        unloadingDetentionClientConfig);
    }
    return days;
  }

  calculateDeliveryDetentionBasedOnExpectedDeliveryAndClientConfig(data, depotCalenderMap) {
    const unloadingDetentionClientConfig = data.detentionClientConfig &&
      data.detentionClientConfig.unloadingDetention;
    let days = 0;
    days = this.calculateDeliveryDetentionBasedOnClientConfiguration(data, depotCalenderMap,
      unloadingDetentionClientConfig);
    return days;
  }

  calculateDeliveryDetentionWithTransitDaysCharges(data, depotCalenderMap, depotConfiguration) {
    let charges = 0;

    if (data.orderType === OrderType.OPEN && !(depotConfiguration
      && depotConfiguration.open_indents_charge
      && depotConfiguration.open_indents_charge.unloading_detention_charge)) {
      return 0;
    }
    const days = this.calculateDeliveryDetentionBasedOnExpectedDelivery(data, depotCalenderMap);
    if (days) {
      // Priority 1: Check indentDestinationCharges for unloading_detention
      let unloadingDetentionCharge = null;
      const destination = data.destinations && data.destinations[0];
      const destinationLocationId = destination && destination.locationId;
      const destinationGateId = destination && destination.destinationGateId;
      
      if (destinationLocationId) {
        unloadingDetentionCharge = Helper.getUnloadingDetentionFromDestinationCharges(data, destinationLocationId, destinationGateId);
      }
      
      // Priority 2: Fallback to detention master
      if (!unloadingDetentionCharge) {
        const detentionCharge = Helper.getDetentionCharge(data);
        unloadingDetentionCharge = (detentionCharge && detentionCharge.unloading_detention) || [0];
      }
      
      charges = this.calculateChargeForDetention(unloadingDetentionCharge, days);
    }
    return charges;
  }

  calculateDeliveryDetentionWithTransitDaysChargesBasedOnClientConfig(data,
    depotCalenderMap, depotConfiguration) {
    let charges = 0;

    if (data.orderType === OrderType.OPEN && !(depotConfiguration
      && depotConfiguration.open_indents_charge
      && depotConfiguration.open_indents_charge.unloading_detention_charge)) {
      return 0;
    }

    const days = this.calculateDeliveryDetentionBasedOnExpectedDeliveryAndClientConfig(data,
      depotCalenderMap);
    if (days) {
      // Priority 1: Check indentDestinationCharges for unloading_detention
      let unloadingDetentionCharge = null;
      const destination = data.destinations && data.destinations[0];
      const destinationLocationId = destination && destination.locationId;
      const destinationGateId = destination && destination.destinationGateId;
      
      if (destinationLocationId) {
        unloadingDetentionCharge = Helper.getUnloadingDetentionFromDestinationCharges(data, destinationLocationId, destinationGateId);
      }
      
      // Priority 2: Fallback to detention master
      if (!unloadingDetentionCharge) {
        const detentionCharge = Helper.getDetentionCharge(data);
        unloadingDetentionCharge = (detentionCharge && detentionCharge.unloading_detention) || [0];
      }
      
      charges = this.calculateChargeForDetention(unloadingDetentionCharge, days);
    }
    return charges;
  }

  getPayments() {
    const Payments = require('../../payments');
    return new Payments();
  }

  async calculateDeliveryDetentionWithTransitDays(_data, depotCalenderMap, depotConfiguration) {
    let data = _data;
    let days = 0;
    const payments = this.getPayments();
    data = payments.groupConsignees(data);
    if (data.orderType === OrderType.OPEN && !(depotConfiguration
      && depotConfiguration.open_indents_charge
      && depotConfiguration.open_indents_charge.unloading_detention_charge)) {
      return 0;
    }
    days = this.calculateDeliveryDetentionBasedOnExpectedDelivery(data, depotCalenderMap);
    return days;
  }

  async calculateDeliveryDetentionWithTransitDaysBasedOnClientConfig(_data,
    depotCalenderMap, depotConfiguration) {
    let data = _data;
    let days = 0;
    const payments = this.getPayments();
    data = payments.groupConsignees(data);
    if (data.orderType === OrderType.OPEN && !(depotConfiguration
      && depotConfiguration.open_indents_charge
      && depotConfiguration.open_indents_charge.unloading_detention_charge)) {
      return 0;
    }
    days = this.calculateDeliveryDetentionBasedOnExpectedDeliveryAndClientConfig(data,
      depotCalenderMap);
    return days;
  }
}

module.exports = UnloadingDetention;
